<template>
  <div>
    <custom-input
      label="Key Account Name"
      :value="name"
      @input="$store.commit('changeName', $event)"
    />

    <custom-input
      label="Type of Key Account"
      :value="type"
      @input="$store.commit('changeType', $event)"
    />

    <div class="form-group" v-if="! nav && stepType === 'trial'">
      <label class="custom-label" for="test_agreement">Test Agreement</label>
      <br>
      <template v-if="document">
        <p><a :href="`/trials/${trial.id}/key_account/document`" target="_blank">Show Test Agreement</a></p>
        <button class="btn btn-secondary btn-sm"
          @click.prevent="deleteTestAgreement"
        >
          Delete Test Agreement <i class="fa fa-trash-alt"></i>
        </button>
      </template>
      <input type="file" name="test_agreement" id="test_agreement"
        v-else
        @change="uploadTestAgreement"
      >
    </div>

    <div class="form-group">
      <label class="custom-label">Sales</label>
      <div class="row">
        <div class="col-sm-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width: 50px;">
                <i class="fa fa-user-tie"></i>
              </span>
            </div>
            <input class="form-control" placeholder="Name"
              :value="sales.name"
              @input="$store.commit('changeSalesName', $event.target.value)"
            >
          </div>
        </div>
        <div class="col-sm-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width: 50px;">
                <i class="fa fa-phone"></i>
              </span>
            </div>
            <input class="form-control" placeholder="Phone Number"
              :value="sales.phone"
              @input="$store.commit('changeSalesPhone', $event.target.value)"
            >
          </div>
        </div>
        <div class="col-sm-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width: 50px;">
                <i class="fa fa-at"></i>
              </span>
            </div>
            <input class="form-control" placeholder="Email"
              :value="sales.email"
              @input="$store.commit('changeSalesEmail', $event.target.value)"
            >
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="custom-label">Marketing</label>
      <div class="row">
        <div class="col-sm-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width: 50px;">
                <i class="fa fa-user-tie"></i>
              </span>
            </div>
            <input class="form-control" placeholder="Name"
              :value="marketing.name"
              @input="$store.commit('changeMarketingName', $event.target.value)"
            >
          </div>
        </div>
        <div class="col-sm-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width: 50px;">
                <i class="fa fa-phone"></i>
              </span>
            </div>
            <input class="form-control" placeholder="Phone Number"
              :value="marketing.phone"
              @input="$store.commit('changeMarketingPhone', $event.target.value)"
            >
          </div>
        </div>
        <div class="col-sm-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width: 50px;">
                <i class="fa fa-at"></i>
              </span>
            </div>
            <input class="form-control" placeholder="Email"
              :value="marketing.email"
              @input="$store.commit('changeMarketingEmail', $event.target.value)"
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <custom-input
          label="Overall Number of Stores"
          :value="stores.number"
          @input="$store.commit('changeStoresNumber', $event)"
        />
      </div>
      <div class="col-sm-6" v-if="stepType === 'trial'">
        <custom-input
          label="Potential Number of Rollout Stores"
          :value="stores.potentialRollouts"
          @input="$store.commit('changeStoresPotentialRollouts', $event)"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="custom-label" for="stores_description">Description Project & Latest Status Quo</label>
      <textarea class="form-control" id="stores_description"
        :value="stores.description"
        @input="$store.commit('changeStoresDescription', $event.target.value)"
        rows="5"
      ></textarea>
    </div>


    <div style="margin-top: 1em;" v-if="nav">
      <button type="button" class="btn btn-primary float-left"
        @click="$router.push(`/${stepType === 'trial' ? 'trials' : 'roll_outs'}/create`)"
        v-text="'Back'"
      />
      <button type="button" class="btn btn-primary float-right"
        @click="$router.push(`/${stepType === 'trial' ? 'trials' : 'roll_outs'}/create/3`)"
        v-text="'Next'"
      />
    </div>
    <template v-else>
      <button class="btn btn-primary float-right"
        v-if="isAdmin || isFromAuthUser"
        @click.prevent="$emit('update')"
        style="margin-bottom: 1em;"
      >
        <i class="fa fa-edit"></i> Save
      </button>
    </template>
    <key-account-files-upload-modal
      :type="fileType" :url="url"
      @fileUploaded="fileUploaded"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import StepMixin from './step-mixin'

  export default {
    mixins: [ StepMixin ],
    props: {
      trial: {
        default() {
          return {
            key_account: null,
          }
        },
      },
      rollOut: {
        default() {
          return {
            key_account: null,
          }
        },
      },
    },
    data() {
      return {
        document: this.trial.key_account ? this.trial.key_account.document : null,
        fileType: '',
        url: '',
      }
    },
    methods: {
      uploadTestAgreement(event) {
        const formData = new FormData
        formData.append('file', event.target.files[0])
        const documentUploadUrl = `/trials/${this.trial.id}/key_account/document`
        axios.post(documentUploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(({data}) => {
          this.document = data
          window.notification.success('Test Agreement has been uploaded', 'Success!')
        })
      },
      deleteTestAgreement() {
        if (confirm('Do you really want to delete the test agreement?')) {
          axios.delete(`/trials/${this.trial.id}/key_account/document`).then(({data}) => {
            this.document = null
            window.notification.success('Test Agreement has been deleted', 'Success!')
          })
        }
      },
      deleteDistributerFile() {
        if (confirm('Do you really want to delete the Agreement Distributor?')) {
          axios.delete(`/roll_outs/${this.rollOut.id}/key_account/files/${this.distributerFile.id}`).then(({data}) => {
            this.distributerFile = null
            window.notification.success('Agreement Distributor has been deleted', 'Success!')
          })
        }
      },
      deleteKeyAccountFile() {
        if (confirm('Do you really want to delete the Agreement Key Account ?')) {
          axios.delete(`/roll_outs/${this.rollOut.id}/key_account/files/${this.keyAccountFile.id}`).then(({data}) => {
            this.keyAccountFile = null
            window.notification.success('Agreement Key Account has been deleted', 'Success!')
          })
        }
      },
      uploadDistributerFile(event) {
        this.uploadSingleFile(event.target.files[0], 'distri').then(({data}) => {
          this.distributerFile = data
          window.notification.success('Agreement Distributor  has been uploaded', 'Success!')
        })
      },
      uploadKeyAccountFile(event) {
        this.uploadSingleFile(event.target.files[0], 'ka').then(({data}) => {
          this.keyAccountFile = data
          window.notification.success('Agreement Key Account  has been uploaded', 'Success!')
        })
      },
      uploadSingleFile(file, type) {
        const formData = new FormData
        formData.append('file', event.target.files[0])
        formData.append('type', type)
        const fileUploadUrl = `/roll_outs/${this.rollOut.id}/key_account/files`
        return axios.post(fileUploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      },
      openUploadModal(fileType) {
        this.fileType = fileType
        this.url = `/roll_outs/${this.rollOut.id}/key_account/files`
        this.$nextTick(() => $('#keyAccountFilesUploadModal').modal('show'))
      },
      fileUploaded(data) {
        if (data.fileType === 'distri_add') {
          this.$store.commit('addDistributerFile', data.res)
        } else {
          this.$store.commit('addKeyAccountFile', data.res)
        }
      },
      deleteFile(file) {
        if (confirm(`Do you really want to delete the file ${file.original_name}?`)) {
          axios.delete(`/roll_outs/${this.rollOut.id}/key_account/files/${file.id}`).then(({data}) => {
            window.notification.success('File has been deleted', 'Success!')
            this.$store.commit('removeFile', file)
          })
        }
      },
    },
    computed: {
      ...mapState(['name', 'type', 'sales', 'marketing', 'stores', 'distributorFiles', 'keyAccountFiles']),
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/CreateStep2.vue